export default __webpack_public_path__ + "static/media/lato-bolditalic.74ccaadc.woff";